import { create } from 'zustand';
import type { CreditTier } from '@/types/persona';

interface CreditState {
  remaining: number;
  tier: CreditTier;
  monthlyAllocation: number;
  setCredits: (remaining: number) => void;
  setTier: (tier: CreditTier, allocation: number) => void;
  deduct: (amount: number) => void;
}

export const useCreditStore = create<CreditState>((set) => ({
  remaining: 0,
  tier: 'free',
  monthlyAllocation: 50,
  setCredits: (remaining) => set({ remaining }),
  setTier: (tier, monthlyAllocation) => set({ tier, monthlyAllocation }),
  deduct: (amount) => set((state) => ({ remaining: Math.max(0, state.remaining - amount) })),
}));
